import { Alert } from 'react-native'
import * as Linking from 'expo-linking'

export async function openInbox(): Promise<void> {
  try {
    const canOpen = await Linking.canOpenURL('message://')

    if (canOpen) {
      await Linking.openURL('message://')
    }

    throw new Error('No email app found')
  } catch {
    Alert.alert('No email app found', 'Please open your email application to continue.')
  }
}
